<template lang="pug">
  .avatar
    .avatar-image
      img(:src="imageSrc")
    template(v-if="isRanking || !!highestRanking")
      RankBadge.avatar-badge(:position="computedPosition")
    template(v-if="$route.path === ('/game')")
      RankBadge.avatar-badge(:points="pointsGame" :mini="mini" :jobTitle="jobTitle" isGame)
    template(v-if="$route.path === ('/performance')")
      RankBadge.avatar-badge(:points="pointsPerformance" :mini="mini" :jobTitle="jobTitle")
</template>

<script>
import RankBadge from './RankBadge'

export default {
  name: 'UserAvatar',
  components: { RankBadge },
  props: {
    jobTitle: {
      type: String,
      default: '',
    },
    imgUrl: {
      type: String,
      default: '',
    },
    pointsGame: {
      type: Number,
      default: 0,
    },
    pointsPerformance: {
      type: Number,
      default: 0,
    },
    mini: { type: Boolean, default: false },
    isRanking: { type: Boolean, default: false },
    position: { type: Number, default: null },
    highestRanking: { type: Object, default: null },
  },
  computed: {
    imageSrc() {
      return this.imgUrl ? this.imgUrl : '/images/generic-avatar.svg'
    },
    computedPosition() {
      if (this.isRanking) return this.position
      return this.highestRanking?.ranking
    },
  },
}
</script>

<style lang="sass" scoped>
.avatar
  position: relative
  &-image
    height: 100%
    width: 100%
    border-radius: 100%
    background: gray
    border: 2px solid white
    box-shadow: 0 3px 6px 0px rgba(0,0,0,.2)
    img
      width: 100%
      height: 100%
      border-radius: 100%
      object-fit: cover
  &-badge
    position: absolute
    min-width: 35%
    height: 35%
    top: 67.5%
    left: 67.5%
</style>
